import React, {useContext} from 'react';
import {PropertiesContext} from "@providers/properties";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import styled from "styled-components";
import {isEmpty} from "@helpers/helpers";
import Divider from "@atoms/divider";

const SearchPageTitle = ({searchTitle, skeleton, isServerSide, categories, urlParams, forceShowNoResult, className}) => {
    const properties_context = useContext(PropertiesContext);
    const {properties} = properties_context;

    return (
        <div className={"mt-16 mt-lg-56 " + (className ?? '')}>
            <h1 className="h1">
                {
                    ((categories === 'my_properties' || categories === 'follow') || (!isEmpty(urlParams) && (!isEmpty(urlParams['categories[my_properties]']) || !isEmpty(urlParams['follow'])))) ?
                        <React.Fragment>

                            {
                                (categories === 'my_properties') ?
                                    'آگهی‌های من'
                                    : (
                                        (categories === 'follow') ?
                                            'آگهی‌های نشان شده'
                                            : ''
                                    )
                            }

                            {
                                (properties.length && !forceShowNoResult) ?
                                    <Divider className="mt-24 mt-lg-56 mb-0"/>
                                    : ''
                            }
                        </React.Fragment>
                        :
                        (
                            (skeleton && !isServerSide) ?
                                <SkeletonTheme color={props => props.theme.gray200} highlightColor="#444">
                                    <TitleSkeleton>
                                        <Skeleton height="100%" width="100%"/>
                                    </TitleSkeleton>
                                </SkeletonTheme>
                                :
                                searchTitle
                        )
                }
            </h1>
        </div>
    );
};

function propsAreEqual(prevProps, nextProps) {
    return (
        (prevProps.skeleton === nextProps.skeleton)
        && (prevProps.searchTitle === nextProps.searchTitle)
        && (prevProps.categories === nextProps.categories)
        && (prevProps.forceShowNoResult === nextProps.forceShowNoResult)
        && (prevProps.isServerSide === nextProps.isServerSide)
    );
}

export default React.memo(SearchPageTitle, propsAreEqual);

// styles

const TitleSkeleton = styled.div`
    width: 35%;
    height: 27px;

    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        width: 80%;
    }
`;
